export default class MuNavToggles {
    _$nav;
    _isOpen = false;
    _children = [];

    constructor(selector, children) {
        this._nav =
            typeof selector === "string"
                ? document.querySelector(selector)
                : selector;
        if (this._nav) {
            this._init(children);
        }
    }

    _init(children) {
        this._$hasChildren = $(children, this._nav);
        $.each(this._$hasChildren, (i, el) => {
            const child = new MuNavToggle(el);
            this._children.push(child);
        });
    }
}

class MuNavToggle {
    _$nav;
    _children = [];

    constructor(el) {
        this._$nav = $(el);
        if (this._$nav) {
            this._init();
        }
    }

    set tabbing(value) {
        this._$navItems.attr("tabindex", value ? 0 : -1);
    }

    get hasChildren() {
        return this._children.length > 0;
    }

    _init() {
        // recursively get children
        $.each($("> .nav > .has-children", this._$nav), (i, el) => {
            const child = new MuNavToggle(el);
            this._children.push(child);
        });

        this._$navToggle = $(
            "> .nav-title-container > button.nav-link-toggle",
            this._$nav
        );
        this._$navItems = $(
            "> .nav > .nav-item > a, " +
                "> .nav > .nav-item > .nav-title-container > a, " +
                "> .nav > .nav-item > .nav-title-container > button",
            this._$nav
        );

        if (this._$navToggle.length > 0) {
            this._$navToggle.on("click", (e) => this._toggle(e));
        }
    }

    open() {
        if (!this._$nav.hasClass("is-open")) {
            this._$nav.addClass("is-open");
            this._$currentToggle.attr("aria-expanded", true);
            this.tabbing = true;
        }
    }

    close() {
        if (this._$nav.hasClass("is-open")) {
            if (this._$currentToggle) {
                this._$nav.removeClass("is-open");
                this._$currentToggle.attr("aria-expanded", false);
            }
            this.tabbing = false;
            if (this.hasChildren) {
                this.closeAll();
            }
        }
    }

    closeAll() {
        this._children.forEach((child) => child.close());
    }

    _toggle(e) {
        this._$currentToggle = $(e.target);
        if (!this._$nav.hasClass("is-open")) {
            this.open();
        } else {
            this.close();
        }
    }
}
